import { isAuthDeniedError } from './cartRecovery.js'

/**
 * Load the member used to initialize the cart.
 * A 401/403 means the stored session was rejected (revoked, expired, or issued
 * before revocable session tokens). That is a guest, not a cart-init failure.
 * Other errors still abort init so real outages stay visible.
 */
export async function loadMemberForCartInit({ loadUser, clearSession }) {
	try {
		return { user: await loadUser(), clearedStaleSession: false }
	} catch (error) {
		if (!isAuthDeniedError(error)) throw error
		clearSession()
		return { user: null, clearedStaleSession: true }
	}
}
